/**
 * @generated SignedSource<<a61b008901f2653c7bdf2ac8405794af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ProblemGeneratorActionEnum = "generated_problems_create" | "problem_generator_activate" | "problem_generator_assign" | "problem_generator_deactivate" | "problem_generator_publish" | "%future added value";
export type ProblemGeneratorDeactivateInput = {
  assignedTo: string;
  id: string;
};
export type ProblemGeneratorDeactivateDialog_problemGeneratorDeactivateMutation$variables = {
  input: ProblemGeneratorDeactivateInput;
};
export type ProblemGeneratorDeactivateDialog_problemGeneratorDeactivateMutation$data = {
  readonly problemGeneratorDeactivate: {
    readonly actions: ReadonlyArray<ProblemGeneratorActionEnum>;
    readonly assigned: any | null;
    readonly assignedTo: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"UserAvatarText_user">;
    } | null;
    readonly id: string;
    readonly " $fragmentSpreads": FragmentRefs<"ProblemGeneratorProblemGeneratorHistoryPaginator_problemGenerator" | "ProblemGeneratorStatusLabel_problemGenerator">;
  };
};
export type ProblemGeneratorDeactivateDialog_problemGeneratorDeactivateMutation = {
  response: ProblemGeneratorDeactivateDialog_problemGeneratorDeactivateMutation$data;
  variables: ProblemGeneratorDeactivateDialog_problemGeneratorDeactivateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "actions",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "assigned",
  "storageKey": null
},
v5 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "picture",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDeleted",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v10 = [
  (v9/*: any*/),
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "before",
    "storageKey": null
  },
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "after",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ProblemGeneratorDeactivateDialog_problemGeneratorDeactivateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ProblemGenerator",
        "kind": "LinkedField",
        "name": "problemGeneratorDeactivate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProblemGeneratorStatusLabel_problemGenerator"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ProblemGeneratorProblemGeneratorHistoryPaginator_problemGenerator"
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "assignedTo",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "UserAvatarText_user"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ProblemGeneratorDeactivateDialog_problemGeneratorDeactivateMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ProblemGenerator",
        "kind": "LinkedField",
        "name": "problemGeneratorDeactivate",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "concreteType": "ProblemGeneratorHistoryConnection",
            "kind": "LinkedField",
            "name": "histories",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "totalCount",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "PageInfo",
                "kind": "LinkedField",
                "name": "pageInfo",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "endCursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "hasNextPage",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ProblemGeneratorHistoryEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "cursor",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProblemGeneratorHistory",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "type",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "User",
                        "kind": "LinkedField",
                        "name": "createdBy",
                        "plural": false,
                        "selections": [
                          (v6/*: any*/),
                          (v7/*: any*/),
                          (v2/*: any*/),
                          (v8/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "created",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "difference",
                        "plural": false,
                        "selections": [
                          (v9/*: any*/),
                          {
                            "kind": "TypeDiscriminator",
                            "abstractKey": "__isDifference"
                          },
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "generatedCount",
                                "plural": false,
                                "selections": (v10/*: any*/),
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Diff",
                                "kind": "LinkedField",
                                "name": "publishedProblemsCount",
                                "plural": false,
                                "selections": (v10/*: any*/),
                                "storageKey": null
                              }
                            ],
                            "type": "ProblemGeneratorDifference",
                            "abstractKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v9/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "histories(first:10)"
          },
          {
            "alias": null,
            "args": (v5/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "ProblemGeneratorProblemGeneratorHistoryPaginator_problemGenerator_histories",
            "kind": "LinkedHandle",
            "name": "histories"
          },
          (v4/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "assignedTo",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "c0720882c968a4934231356bdd281d74",
    "id": null,
    "metadata": {},
    "name": "ProblemGeneratorDeactivateDialog_problemGeneratorDeactivateMutation",
    "operationKind": "mutation",
    "text": "mutation ProblemGeneratorDeactivateDialog_problemGeneratorDeactivateMutation(\n  $input: ProblemGeneratorDeactivateInput!\n) {\n  problemGeneratorDeactivate(input: $input) {\n    id\n    actions\n    ...ProblemGeneratorStatusLabel_problemGenerator\n    ...ProblemGeneratorProblemGeneratorHistoryPaginator_problemGenerator\n    assigned\n    assignedTo {\n      id\n      ...UserAvatarText_user\n    }\n  }\n}\n\nfragment DiffItem_diff on Diff {\n  before\n  after\n}\n\nfragment ProblemGeneratorDifferenceCounterLabel_difference on Difference {\n  __isDifference: __typename\n  ... on ProblemGeneratorDifference {\n    generatedCount {\n      __typename\n    }\n    publishedProblemsCount {\n      __typename\n    }\n  }\n}\n\nfragment ProblemGeneratorDifferenceItemList_difference on Difference {\n  __isDifference: __typename\n  ... on ProblemGeneratorDifference {\n    generatedCount {\n      ...DiffItem_diff\n    }\n    publishedProblemsCount {\n      ...DiffItem_diff\n    }\n  }\n}\n\nfragment ProblemGeneratorHistoryDialog_problemGeneratorHistory on ProblemGeneratorHistory {\n  createdBy {\n    name\n    picture\n    id\n  }\n  created\n  difference {\n    __typename\n    ...ProblemGeneratorDifferenceCounterLabel_difference\n    ...ProblemGeneratorDifferenceItemList_difference\n  }\n}\n\nfragment ProblemGeneratorHistoryTimelineItem_problemGeneratorHistory on ProblemGeneratorHistory {\n  created\n  createdBy {\n    id\n    ...UserAvatarText_user\n  }\n  type\n}\n\nfragment ProblemGeneratorProblemGeneratorHistoryPaginator_problemGenerator on ProblemGenerator {\n  histories(first: 10) {\n    totalCount\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n    edges {\n      cursor\n      node {\n        id\n        type\n        ...ProblemGeneratorHistoryDialog_problemGeneratorHistory\n        ...ProblemGeneratorHistoryTimelineItem_problemGeneratorHistory\n        __typename\n      }\n    }\n  }\n  id\n}\n\nfragment ProblemGeneratorStatusLabel_problemGenerator on ProblemGenerator {\n  status\n}\n\nfragment UserAvatarText_user on User {\n  name\n  picture\n  isDeleted\n}\n"
  }
};
})();

(node as any).hash = "3080907520b6ced0e67034a0a25cd574";

export default node;
